import React, {Component, Fragment} from 'react';
import {Button, Card, CardBody, CardHeader} from 'reactstrap';
import 'ladda/dist/ladda-themeless.min.css';
import 'react-bootstrap-table/dist/react-bootstrap-table-all.min.css';
import {getData} from '../../../api/doLogin.js';
import {BootstrapTable, TableHeaderColumn} from "react-bootstrap-table";
import "video-react/dist/video-react.css";
import {RequiredPermissions} from "../../../api/permissions";
import {hasPermission} from "../../../api/permissionHelper";
import {getGlobalState, setGlobalState} from "../../../constants/GlobalStore";
import {EventClient} from "../../../util/eventClient";

const brandPrimary = '#20a8d8';
const brandSuccess = '#4dbd74';
const brandInfo = '#63c2de';
const brandWarning = '#f8cb00';
const brandDanger = '#f86c6b';

export class UserList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      data: [],
      active: true,
      dataLoaded: false,
      preview: null,
      showPicker: false,
      tempData: {}
    };

    this.table = this.state.data || [];
    this.options = {
      sortIndicator: true,
      hideSizePerPage: true,
      paginationSize: 50,
      hidePageListOnlyOnePage: true,
      clearSearch: true,
      alwaysShowAllBtns: false,
      withFirstAndLast: false
    }
    this.accessLevel = 1;
  }

  componentDidMount() {
    // this.accessLevel = checkPerms(this.props.perms, [{admin: {cameras: [2]}}]) ? 2 : this.accessLevel;
    // this.accessLevel = checkPerms(this.props.perms, [{admin: {cameras: [3]}}]) ? 3 : this.accessLevel;
    this.updateData();
  }

  // componentDidUpdate(prevProps, prevState) {
  //   if (prevProps.match.params.type !== this.props.match.params.type) {
  //     this.updateData();
  //   }
  // }

  updateData() {
    var self = this;
    getData(`admin/users/${this.state.active ? "active" : "archived"}`, {})
      .then((data) => {
        if (data.status === "Success") {
          self.setState({data: data.data.users, dataLoaded: true});
        }
      })
      .catch(error => {
        console.error(error);
      });
  }

  sUser(user) {
    var self = this;
    getData(`admin/users/${user}/simulate`, {})
      .then((data) => {
        if (data.status === "success") {
          EventClient.emit("TOAST_SUCCESS", "Success Please Wait...");
          const {id, token, expiresAt, perms, lmsMenu} = data.data;
          setGlobalState({
            loginID: id,
            token: token,
            expiresAt: expiresAt,
            lastActive: new Date(),
            perms: perms,
            lmsMenu,
            origUser: getGlobalState("loginID"),
          });
          self.props.history.push(`/`);
          // self.setState({data: data.data.users, dataLoaded: true});
        } else {
          EventClient.emit("TOAST_ERROR", data.message || "Error Simulating User");
          console.error(data);
        }
      })
      .catch(error => {
        console.error(error);
      });
  }

  actionFormatter(cell, row, self) {
    return <Fragment>
      <Button
        onClick={() => {
          self.props.history.push(`/admin/users/${row.id}`);
        }}
      >Edit</Button>
      {/*<Button onClick={() => this.setState({*/}
      {/*  showPicker: true,*/}
      {/*  tempData: {cameraId: row['camera_id'], dated: row['dated']}*/}
      {/*})}>LMS</Button>*/}

      {row.id !== 1 && !getGlobalState("origUser") && row.id !== getGlobalState("loginID") && hasPermission(RequiredPermissions.UsersSimulate) && (
        <Button
          onClick={() => {
            this.sUser(row.id);
          }}
        >Simulate</Button>
      )}

    </Fragment>
  }

  render() {
    return (
      <div className="animated fadeIn">
        {this.state.dataLoaded && (
          <Card>
            <CardHeader>
              <i className="icon-menu"></i>{this.state.active ? "Active" : "Archived"} Users
              <div className="card-actions">
                {this.state.active && (
                  <button onClick={() => {
                    this.props.history.push(`/admin/users/new`);
                  }}>
                    <small className="text-muted">Add</small>
                  </button>
                )}
                <button onClick={() => {
                  this.setState({active: !this.state.active}, () => this.updateData());
                }}>
                  <small className="text-muted">{!this.state.active ? "Active" : "Archived"}</small>
                </button>
                <button onClick={() => this.updateData()}>
                  <small className="text-muted">Refresh</small>
                </button>
              </div>

            </CardHeader>
            <CardBody>
              <BootstrapTable data={this.state.data} version="4" striped hover pagination search options={this.options}>
                <TableHeaderColumn isKey={true} dataField="id" hidden>Id</TableHeaderColumn>
                <TableHeaderColumn dataField="display" dataSort>Name</TableHeaderColumn>
                <TableHeaderColumn dataField="email" dataSort>Email</TableHeaderColumn>
                <TableHeaderColumn dataField="officeDisplay" dataSort>Office</TableHeaderColumn>
                <TableHeaderColumn dataField="button"
                                   dataFormat={(cell, row) => this.actionFormatter(cell, row, this)}
                >Actions</TableHeaderColumn>
              </BootstrapTable>
            </CardBody>
          </Card>
        )}
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/containers/Admin/Users/UserList.js